import { render, staticRenderFns } from "./AvailabilityQueue.vue?vue&type=template&id=2efd6188"
import script from "./AvailabilityQueue.vue?vue&type=script&lang=ts"
export * from "./AvailabilityQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports